import axios from 'axios';

const instance = axios.create({})

export default {
    getAcademySettings: () => {
        return new Promise((resolve, reject) => {
            instance.get("/ap.config.json?v=20260106050753").then(response => {
                resolve(response.data);
            }).catch(err => {
                reject(err.response);
            })
        })
    },
    getJsonFile: (path) => {
        return new Promise((resolve, reject) => {            
            instance.get(`/${path}.json?v=20260106050753`).then(response => {
                resolve(response.data);
            }).catch(err => {
                reject(err.response);
            })
        });
    }
}
  
